import WarningIcon from '@material-ui/icons/Warning';
import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';

export const RoleCheckFailure = () => (
  <Stack
    css={`
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      min-width: 0;
      flex: 1 1 auto;
    `}
  >
    <Stack alignX="center" alignY="center" vertical css="flex: 1;">
      <Text variant="display4" css="font-size: 10rem;">
        <WarningIcon />
      </Text>
      <Text>You do not have access to this resource</Text>
    </Stack>
  </Stack>
);
